











import { computed, defineComponent } from "@vue/composition-api";
import ClickOutside from "vue-click-outside";
import { useStore } from "@/store";

export default defineComponent({
  name: "RightDrawer",
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: "20%"
    },
    zIndex: {
      type: Number,
      default: 2,
      // NavigationDrawerがz-index: 10なので、10未満で設定させる
      // c.f. https://github.com/OneCareerJP/cloud/blob/0d23f4e5e9b53821d09fd68e6417fea9fa4957cc/frontend/src/components/Organisms/NavigationDrawer/NavigationDrawer.vue#L353
      validator: (value: number) => {
        return value > 1 && value < 10;
      }
    }
  },
  directives: { ClickOutside },
  emits: ["click-outside"],
  setup(props, { emit }) {
    const store = useStore();

    const rightDrawerStyle = computed(() => {
      return { minWidth: props.minWidth, zIndex: props.zIndex };
    });

    const activeStatusClass = computed(() => {
      const cssClasses = [];

      if (
        store.state.domains.user.partnerUser?.logged_in_by_proxy &&
        store.getters["domains/user/isScoutAgentMenuActive"]
      ) {
        // 代理ログイン&エージェントメニュー表示中はヘッダーバー2つ分の高さを確保する
        cssClasses.push("right-drawer__header-bar-active-twice");
      } else if (
        store.state.domains.user.partnerUser?.logged_in_by_proxy ||
        store.getters["domains/user/isScoutAgentMenuActive"]
      ) {
        // 代理ログインorエージェントメニュー表示中はヘッダーバー1つ分の高さを確保する
        cssClasses.push("right-drawer__header-bar-active");
      }
      if (props.isShow) {
        cssClasses.push("right-drawer__active");
      } else {
        cssClasses.push("right-drawer__inactive");
      }

      return cssClasses;
    });

    const handleClickedOutsideDrawer = () => {
      emit("click-outside");
    };

    return {
      rightDrawerStyle,
      activeStatusClass,
      handleClickedOutsideDrawer
    };
  }
});
